import { render, staticRenderFns } from "./DocumentRequestSection.vue?vue&type=template&id=370a55d5"
import script from "./DocumentRequestSection.vue?vue&type=script&lang=js"
export * from "./DocumentRequestSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports